import React, { useEffect, useState } from 'react';
import { AdminUserDetails } from '../../../../types/user';
import UsersTable from './UsersTable';
import { Box, Skeleton } from '@mui/material';
import { callAPISync, getAdminUsers } from '../../../../utils/api';
import Logger from '../../../../utils/logger';
import { useLogto } from '@logto/react';

const UserViewTab: React.FC = () => {
	const logto = useLogto();

	const [users, setUsers] = useState<AdminUserDetails[]>([]);

	useEffect(() => {
		callAPISync(logto, (token) => {
			getAdminUsers(token)
				.then((res) => res.json())
				.then((json) => setUsers(json as AdminUserDetails[]))
				.catch((e) => {
					Logger.warn(String(e));
				});
		});
	}, []);

	return <Box width="100%">{users.length > 0 ? <UsersTable usersData={users} /> : <Skeleton variant="rounded" height={120} />}</Box>;
};

export default UserViewTab;
